import product from "./product";

export default {
    product,

    noAvailableItems: "Geen producten beschikbaar om te bestellen."
}